export const Breakpoints = {
    xs: '375px',
    sm: '768px',
    lg: '1024px',
    xl: '1280px',
    xxl: '1600px',
};
